import classNames from 'classnames';
import React, { useMemo, useState } from 'react';

import { TreeItem, TreeItemCheckEvent } from '../Tree.types';
import { getCheckState } from '../Tree.utils';
import TreeGroup from '../TreeGroup';
import TreeCollapseButton from './TreeCollapseButton';
import TreeNodeLabel from './TreeItemLabel';

interface Props {
  item: TreeItem;
  isHidden: boolean;
  treeId: string;
  onCheck: (event: TreeItemCheckEvent) => void;
}

const TreeItemNode: React.FC<Props> = React.memo(({ item, onCheck, isHidden, treeId }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const itemOnCheck = () => {
    onCheck({ item, checked: getCheckState(item) });
  };

  const onExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const renderChildren = useMemo(() => {
    return (
      <>
        {isExpanded && item.isParent && Array.isArray(item.values) ? (
          <TreeGroup items={item.values} parent={item} treeId={treeId} onItemCheck={onCheck} />
        ) : null}
      </>
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item.values, isExpanded]);

  const className = classNames([`depth-${item.depth.length}`]);

  return (
    <>
      <li style={isHidden ? { display: 'none' } : {}} className={className}>
        <TreeCollapseButton item={item} isExpanded={isExpanded} onExpand={onExpand} />
        <TreeNodeLabel item={item} onCheck={itemOnCheck} treeId={treeId} />
      </li>
      {renderChildren}
    </>
  );
});

export default TreeItemNode;
